import { MenuItem } from '@mui/material'
import { ActionsItemProps } from './actions'
import { Send } from '@mui/icons-material'
import { useTurnOrderStore } from 'modules/orders/components/turnOrderModal/turnOrderStore'

export const TurnOrder = ({ order, disabled }: ActionsItemProps) => {
  const setModalOpen = useTurnOrderStore.useSetModalOpen()
  const setProposalId = useTurnOrderStore.useSetProposalId()

  const handleClick = () => {
    setModalOpen(true)
    setProposalId(order?.proposalId)
  }

  return (
    <MenuItem disableRipple onClick={handleClick} disabled={disabled}>
      <Send />
      Transformar em pedido
    </MenuItem>
  )
}
